module.exports = __webpack_public_path__ + "media/images/icons/ko-e10ee8f4110bdc9a65779289c291e5f3.png";